import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../shared";
import { TandaDetails, TandaList } from "./containers";

export const Tanda = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<TandaList />} />
        <Route element={<ProtectedRoute allowedRoute={["tanda-view"]} />}>
          <Route path="/details/:id" element={<TandaDetails />} />
        </Route>
      </Routes>
    </>
  );
};
